import { Divider } from "antd"
import { cadss_catalog_1, cadss_catalog_2, responses } from "../../../../escalas/cads/cads.catalog"


export default function CadsResults({ cads }) {

    // Example of cadss: {"0":true,"1":true,"2":true,"3":true,"4":true,"5":true,"6":true,"7":true,"8":true,"9":3,"10":3,"11":2,"12":1,"13":2,"14":3,"_id":"697bbbd6a9286c4b1e60b474"}



    return (
        <div>
            {/* {JSON.stringify(cads)} */}
            {cadss_catalog_1.map((item, index) => (
                <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                    <td>{item}</td>
                    <td>{cads[index] ? "Si" : "No"}</td>
                </tr>
            ))}

            {
                cadss_catalog_2.map((item, index) => (
                    <tr key={index + 9} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 1 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item}</td>
                        <td>{cads[index + 9]}</td>
                    </tr>
                ))
            }

            <Divider  />
            <p className='desc'>CUESTIONARIO DE GUSTO Y APETENCIA A LA KETAMINA IV</p>

            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#fff', padding: 5, borderRadius: 6 }}>
                <td>1. a.)	En general, ¿cuánto le gustaron los efectos disociativos de la ketamina IV? </td>
                <td>{cads[15]}</td>

            </tr>
            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#f5f5f5', padding: 5, borderRadius: 6 }}>
                <td>2. a.)	En general, ¿cuánto anhela, apetece el tratamiento de la ketamina IV para otros efectos además de los efectos antidepresivos? </td>
                <td>{cads[16]}</td>
            </tr>
            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#fff', padding: 5, borderRadius: 6 }}>
                <td>2. b.)	¿Cuánto desea usar la ketamina IV en cantidades mayores con más frecuencia de lo que su psiquiatra le está prescribiendo por razones distintas a esperar más efecto antidepresivo?   </td>
                <td>{cads[17]}</td>
            </tr>
        </div>
    )
}